import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateTemplateStatus = createSelector(
  [(store: RootState) => store.templateCreate.createStatus],
  (list) => list
);
